import { Table } from 'semantic-ui-react';
import React from 'react';
import StageAssigneeRow from './StageAssigneeRow';
import { FormattedMessage } from 'react-intl';

const prefix = 'stageAssigneeTable';

export default function StageAssigneeTable(props) {
  const stageAssignees = props.stageAssignees;
  return (
    <>
      <div>
        <div className="sub-section-header">
          <FormattedMessage id={`${prefix}.tableHeader`} defaultMessage="STAGE ASSIGNEES" />
        </div>
      </div>
      <Table className="assignee-list-table">
        <Table.Body>
          {stageAssignees?.map((stageAssignee) => {
            return <StageAssigneeRow stageAssignee={stageAssignee} key={stageAssignee.name} />;
          })}
        </Table.Body>
      </Table>
    </>
  );
}
